const BRAND_VERSION = "20260801-brand-ux-v1";

export default function BrandLockup({
  className = "",
  variant = "auto",
  label = "Callsect",
  optimized = false,
  priority = false,
}) {
  const classes = ["brand-lockup", className].filter(Boolean).join(" ");
  const darkSrc = `/callsect-logo-dark.png?v=${BRAND_VERSION}`;
  const lightSrc = `/callsect-logo-light.png?v=${BRAND_VERSION}`;
  // Landing-only optimized variants. The full-resolution PNGs remain the default
  // everywhere else (auth, app, legal and product marketing).
  const selectedDarkSrc = optimized ? "/callsect-logo-dark-600.webp" : darkSrc;
  const selectedLightSrc = optimized ? "/callsect-logo-light-600.webp" : lightSrc;

  return (
    <span className={classes} role="img" aria-label={label}>
      {variant !== "light" && (
        <img
          src={selectedDarkSrc}
          alt=""
          aria-hidden="true"
          width={optimized ? 600 : 1865}
          height={optimized ? 169 : 525}
          fetchPriority={priority ? "high" : undefined}
          className={`brand-lockup__image${variant === "auto" ? " brand-lockup__image--dark" : ""}`}
          draggable="false"
        />
      )}
      {variant !== "dark" && (
        <img
          src={selectedLightSrc}
          alt=""
          aria-hidden="true"
          width={optimized ? 600 : 1865}
          height={optimized ? 169 : 525}
          fetchPriority={priority ? "high" : undefined}
          className={`brand-lockup__image${variant === "auto" ? " brand-lockup__image--light" : ""}`}
          draggable="false"
        />
      )}
    </span>
  );
}
